// 261010 P2-1 (luồng Sky) — sửa `zones` của MỘT bối cảnh: [{ id, name, zonePosition }]. Zone = kiến trúc TĨNH của nơi (≠ setup = thế đứng động).
// Người sửa tay, AI chưa viết zone (Q6). Gửi bằng `PUT /locations/:id` với `zones`. Kiểm ở FE vì BE lặng lẽ BỎ zone sai id/trùng id/thiếu tên.
import React, { useEffect, useState } from 'react';
import { Button, Input, Space, Alert } from 'antd';
import type { FilmLocationZone } from '../../types/film';
import { suggestZoneId, validateZones } from './positionMapUtils';

const same = (a: FilmLocationZone[], b: FilmLocationZone[]) => JSON.stringify(a) === JSON.stringify(b);

const ZonesEditor: React.FC<{ zones: FilmLocationZone[]; onSave: (zones: FilmLocationZone[]) => Promise<void> }> = ({ zones, onSave }) => {
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState<FilmLocationZone[]>(zones);
  /** Dòng mà người đã tự gõ `id` ⇒ ngừng tự gợi ý `id` theo tên. */
  const [idTouched, setIdTouched] = useState<Record<number, boolean>>({});
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState<string[]>([]);
  useEffect(() => { setRows(zones); setErrors([]); setIdTouched({}); }, [zones]);
  const dirty = !same(rows, zones);

  const set = (i: number, patch: Partial<FilmLocationZone>) => setRows((r) => r.map((z, k) => (k === i ? { ...z, ...patch } : z)));
  const save = async () => {
    const { clean, errors: errs } = validateZones(rows);
    setErrors(errs);
    if (errs.length) return;
    setSaving(true);
    try { await onSave(clean); } finally { setSaving(false); }
  };

  return (
    <div data-testid="zones-editor">
      <div className="bk-lbl">
        Khu vực · {zones.length}
        <span style={{ flex: 1 }} />
        <button type="button" className="bk-lnk" onClick={() => setOpen((v) => !v)}>{open ? 'Thu gọn' : zones.length ? 'Xem / sửa' : 'Thêm'}</button>
      </div>
      {!open && zones.length > 0 && <div className="bk-desc" style={{ cursor: 'default' }}>{zones.map((z) => z.name).join(' · ')}</div>}
      {open && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <div style={{ fontSize: 11, color: 'var(--bk-muted)' }}>Kiến trúc tĩnh của nơi (vd "hai mét cuối lối đá trước vòm cổng"). Sơ đồ định vị dùng zone nào thì đổi ở đây sẽ báo "cũ".</div>
          {rows.map((z, i) => (
            <div key={i} style={{ border: '1px solid var(--bk-line)', borderRadius: 6, padding: 6, display: 'flex', flexDirection: 'column', gap: 4 }}>
              <Space.Compact style={{ width: '100%' }}>
                <Input size="small" style={{ width: '38%' }} placeholder="id (a-z 0-9 _ -)" value={z.id}
                  onChange={(e) => { setIdTouched((t) => ({ ...t, [i]: true })); set(i, { id: e.target.value }); }} />
                <Input size="small" placeholder="Tên zone" value={z.name}
                  onChange={(e) => set(i, { name: e.target.value, ...(idTouched[i] || zones.some((o) => o.id === z.id) ? {} : { id: suggestZoneId(e.target.value) }) })} />
              </Space.Compact>
              <Input.TextArea size="small" autoSize={{ minRows: 2, maxRows: 6 }} placeholder="Vị trí / phạm vi trong nơi này" value={z.zonePosition} onChange={(e) => set(i, { zonePosition: e.target.value })} />
              <div style={{ textAlign: 'right' }}><Button size="small" type="text" danger onClick={() => setRows((r) => r.filter((_, k) => k !== i))}>Xoá zone</Button></div>
            </div>
          ))}
          {errors.length > 0 && <Alert type="error" showIcon message={<div style={{ fontSize: 12 }}>{errors.map((e) => <div key={e}>{e}</div>)}</div>} />}
          <Space>
            <Button size="small" onClick={() => setRows((r) => [...r, { id: '', name: '', zonePosition: '' }])}>+ Thêm zone</Button>
            <Button size="small" loading={saving} disabled={!dirty} onClick={save}>Lưu zone</Button>
            <Button size="small" disabled={!dirty} onClick={() => { setRows(zones); setErrors([]); }}>Hoàn tác</Button>
          </Space>
        </div>
      )}
    </div>
  );
};

export default ZonesEditor;
